import React, { useContext, useState } from 'react';
import { Spinner } from '@hz-design-system/web-ui';

import { getXXXXLImageUrl, getHeroImageUrl, getLargeHeroImageUrl } from '../../../../utils/getImageUrls';
import EnvironmentContext from '../../../../contexts/EnvironmentContext';

import Classes from './Carousel.module.scss';

import { TListingGallery } from 'types/TListing';

type TCarouselImageProps = {
  index?: number;
  isModal?: boolean;
  alt: string;
  imageIndex: number;
  imageUrl: string;
  imageSizes?: TListingGallery['media']['imageSizes'];
  onEnterKeyPress?: (index: number) => void;
  preLoadSiblingImages: boolean;
};

const getImageUrl = (imageUrl, isModal, imageSizes, isMobileDevice) => {
  if (isModal) {
    return getXXXXLImageUrl(imageUrl, imageSizes);
  } else {
    return isMobileDevice ? getHeroImageUrl(imageUrl, imageSizes) : getLargeHeroImageUrl(imageUrl, imageSizes);
  }
};

const loadImage = (imageArrayIndex, currentImageIndex, preLoadSiblingImages, isLoaded) =>
  isLoaded || preLoadSiblingImages || currentImageIndex > 0 || imageArrayIndex === 0;

const isSelected = (selectedIndex, currentIndex) => selectedIndex === currentIndex;

const CarouselImage = ({
  alt,
  index = 0,
  isModal = false,
  imageIndex,
  imageUrl,
  imageSizes,
  onEnterKeyPress,
  preLoadSiblingImages,
}: TCarouselImageProps) => {
  const { isMobileDevice } = useContext(EnvironmentContext);
  const [isLoaded, setIsLoaded] = useState(false);
  const tabIndexForImage = !isModal && imageIndex === 0 ? 0 : -1;
  const handleImageLoaded = () => {
    setIsLoaded(true);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onEnterKeyPress) {
      onEnterKeyPress(index);
    }
  };

  return (
    <div className={`${Classes.container} ${isModal ? Classes.dialogContainer : ''}`}>
      {loadImage(imageIndex, index, preLoadSiblingImages, isLoaded) && (
        <>
          {!isLoaded && <Spinner absolute />}
          <img
            className={`${Classes.image} Carousel-image`}
            src={getImageUrl(imageUrl, isModal, imageSizes, isMobileDevice)}
            fetchPriority={isSelected(index, imageIndex) ? 'high' : 'auto'}
            alt={alt}
            tabIndex={tabIndexForImage}
            onKeyDown={handleKeyDown}
            title={alt}
            onLoad={handleImageLoaded}
          />
        </>
      )}
    </div>
  );
};

export default CarouselImage;
